// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-DataExtraction-DataExtractionTemplate-components-WelcomePanel-ChooseTemplateModal-module__CopyModal";
var _2 = "webpack-pages-DataExtraction-DataExtractionTemplate-components-WelcomePanel-ChooseTemplateModal-module__CopyModalInstructions";
var _3 = "webpack-pages-DataExtraction-DataExtractionTemplate-components-WelcomePanel-ChooseTemplateModal-module__RadioGroup";
export { _1 as "CopyModal", _2 as "CopyModalInstructions", _3 as "RadioGroup" }
